import React, { MouseEvent, useEffect, useState } from 'react';
import { Typography, Box, Chip, ToggleButtonGroup } from '@mui/material';
import { ClubFittingType } from 'common/infrastructure/modules/appointment/interfaces/AvailabilityTypes';
import { formatDuration } from 'date-fns';

import { getFittingTypeImage } from 'infrastructure/targets/web/modules/common/imageUrlHelpers';

import { StyledFittingToggleButton } from './style';

interface Props {
  fittingTypes: ClubFittingType[];
  selected: number | undefined;
  onChange: (value: string, event: MouseEvent<HTMLElement>) => void;
}

const FittingTypeSelector: React.FC<Props> = ({ fittingTypes, selected, onChange }) => {
  const [selectedButtonValue, setSelectedButtonValue] = useState<string | number>('');

  const handleChange = (newValue: string, event: MouseEvent<HTMLElement>) => {
    if (onChange) {
      onChange(newValue, event);
    }
    setSelectedButtonValue(newValue);
  };

  useEffect(() => {
    if (selected === undefined) {
      setSelectedButtonValue('');
    }
    if (selected) {
      setSelectedButtonValue(selected);
    }
  }, [selected]);

  return (
    <ToggleButtonGroup
      orientation="vertical"
      value={selectedButtonValue}
      exclusive
      onChange={(event, val) => handleChange(val, event)}
      sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 4 }}>
      {fittingTypes.map((type) => (
        <StyledFittingToggleButton
          key={type.id}
          value={type.id}
          additional-value={Number(type.duration)}
          selected={selected === type.id}>
          <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
            <Box display="flex" alignItems="center" gap={2}>
              <img
                src={getFittingTypeImage(type.name)}
                alt={type.name}
                style={{ width: 48, height: 48 }}
              />
              <Typography variant="subtitle1" fontWeight={500}>
                {type.name}
              </Typography>
            </Box>
            <Chip
              variant="filled"
              size="medium"
              color="default"
              label={formatDuration(
                { hours: Number(type.duration) / 60 },
                { format: ['hours'], zero: true },
              ).replace(/hour/g, 'Hour')}
              sx={{
                ...(selected === type.id && { backgroundColor: 'white' }),
              }}
            />
          </Box>
        </StyledFittingToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default FittingTypeSelector;
